import { inject } from "mobx-react";
import { useEffect } from "react";
import { Store } from "../../../../client/stores";
import { RemoteList } from "../../components/remote/RemoteList.component";
import { getEvents } from "../../services/Calendar";
import type { PageBlockInterface } from "../Block.component";
import { CalendarTile } from "./CalendarTile.component";
import { Sites_Lookup_By } from "@ihr-radioedit/inferno-webapi";

interface CalendarTileLoaderProps extends PageBlockInterface {
    store?: Store;
    slug?: string;
}

export const CalendarTileLoader = inject("store")(({ block, store, slug, isPrimary }: CalendarTileLoaderProps) => {
    if (!store) {
        return null;
    }

    useEffect(() => {
        if (store && block) {
            store.storeBlock(block);
        }
    });
    const cursor = getEvents(store.cache)({
        type: Sites_Lookup_By.Slug,
        value: slug || store.site.index.slug,
        limit: 4,
    });
    return (
        <RemoteList cursor={cursor} showLoading={isPrimary}>
            {({ data }) => <CalendarTile events={data} />}
        </RemoteList>
    );
});

export default CalendarTileLoader;
